import React from 'react';
import NewLogo from '../images/newlogo.png';
const DeliveryReport = (props) => {
 
  const reportData = props.reportData;
  const imageData = props.imageData;
  const reportDate = props.reportDate;
  const reportType = props.reportType;

  const deliveryIntraDayChecked = props.DeliveryIntraDayChecked

  return (
    <div className="img-container">
      <div className='preview-container'>
              <div className='preview-header'>
                <figure><img src={NewLogo} alt='Rakesh Kumar Bansal Ventures' /></figure>
                <h5>51,PKT-A1,Keshav Puram <br/>New Delhi- 110035</h5>
                <div className='right'>
                  <p><b>Research Report Dated:</b> {reportDate.toString()}</p>
                  <p><b>Segment:</b>  {reportType.toString()}</p>
                </div>
              </div>
              <div className='table'>
                <table>
                  <tbody>
                    <tr>
                      <td><b>{reportData.Signal.toString()}</b></td>
                      <td>{reportData.stockType.toString()}</td>
                    </tr>
                   
                    <tr>
                      <td><b>Cash CMP</b></td>
                      <td>{reportData.deliveryCmp.toString()}</td>
                    </tr>
{reportData.deliverySL ?
                    <tr>
                      <td><b>SL</b></td>
                      <td>{reportData.deliverySL.toString()}</td>
                    </tr>
                    :null}
                   
                  </tbody>
                </table>
              </div>
              <div className='remarks'>
             
       {reportData.deliveryRemark1.toString() == ''?null:
      <p><b>Remarks:</b><span style={{ color: reportData.deliverySL === '0' ? 'red' : 'black'}} id="remarks"> {reportData.deliveryRemark1.toString()}</span></p>
  }
      <p>{reportData.commentry.toString()} {reportData.deliveryRemark2.toString() == ''?null:<b>Remark:</b>}{reportData.deliveryRemark2.toString()}</p>
      
      
              </div>
              <div className='chart-image'>
              <img  id="reportimage" src={imageData} alt="chart image" />
                
              </div>
              <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
              <h3 class="report-disclaimer">Disclaimer</h3>
              </div>
      <h5>“Investment in securities market is subject to market risks. Read all the related documents carefully before investing.”</h5>
      <p>We don’t guarantee any kind of profit. Stock market involves risk and trade only if you are comfortable
        with risk.</p> 
        <p> Please don’t trade/invest looking at our performance sheet as Past performance is not the
        guarantee for future performance. </p> 
        <p>Our performance sheet is for our own satisfaction & transparency.  You may or may not be able to buy/sell at our recommended price as recommendations are shared in live/running market and we cannot freeze stock price to help you buy/sell at recommended price. our humble request please trade/invest as per your individual risk appetite.
      </p>
      <p>Registration granted by SEBI and certification from
NISM in no way guarantee performance of the intermediary or provide
any assurance of returns to investors.</p>
      <h5>Please find disclaimer link:
        <a className="disclaimer-link" href="https://www.iamrakeshbansal.com/disclaimer/" target="_blank">
          https://www.iamrakeshbansal.com/disclaimer
        </a>
      </h5>


              <h5 style={{
                borderTop: '1px solid rgba(0,0,0,0.3)',
                borderBottom: '0',
                display: 'flex',
                fontSize: '12px',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                margin: '0',
                // marginTop: '200px',
                padding: '10px'
            }}>
                <span><a href="http://www.iamrakeshbansal.com/">www.iamrakeshbansal.com</a></span>
                <span>SEBI Registration: INH100008984</span>
                <span>Page 1</span>
            </h5>
             
            </div>
     
    </div>
  );
};

export default DeliveryReport;
